/* js/components/mediaPlayers/Youtube.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

import Plyr from 'plyr';
import { onMount, onDestroy } from 'svelte';

function create_if_block(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			attr(div, "data-plyr-provider", "youtube");
			attr(div, "data-plyr-embed-id", /*src*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			/*div_binding*/ ctx[2](div);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 1) {
				attr(div, "data-plyr-embed-id", /*src*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			/*div_binding*/ ctx[2](null);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let if_block = /*src*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			attr(div, "class", "video-container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
		},
		p(ctx, [dirty]) {
			if (/*src*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { src } = $$props;
	let videoDomElement;
	let plyr;

	onMount(() => {
		const options = {
			settings: [],
			hideControls: false,
			fullscreen: { iosNative: true }
		};

		plyr = new Plyr(videoDomElement, options);
	});

	onDestroy(() => {
		if (plyr) {
			plyr.destroy();
		}
	});

	function div_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			videoDomElement = $$value;
			$$invalidate(1, videoDomElement);
		});
	}

	$$self.$$set = $$props => {
		if ('src' in $$props) $$invalidate(0, src = $$props.src);
	};

	return [src, videoDomElement, div_binding];
}

class Youtube extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { src: 0 });
	}
}

export default Youtube;